import {
  ListSitesCommand,
  ListSitesCommandInput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function listSitesService(input: ListSitesCommandInput) {
  const token = await getAuthenticationToken();
  if (!token) {
    Promise.reject(new Error("Unauthorized"));
  }
  const client = setupClaimIntakeClient(token);
  const command = new ListSitesCommand(input);
  const metricsPublisher = new MetricsPublisher("api.listSites");

  return await client
    .send(command)
    .then((response: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
